// extracted by mini-css-extract-plugin
export default {"header":"Header_header__kY-iG","header__title":"Header_header__title__BUwbz","header__step":"Header_header__step__VI8v0"};